export default "/fonts/vendor/boxicons/boxicons.svg?17f6cb4eef77f07f2caae4a0e492f915";